/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Theme for antd
 */
import { ThemeConfig, theme as defaultTheme } from 'antd';
import { ProTokenType } from '@ant-design/pro-components';

const VAR = {
	PRIMARY_COLOR: '#2759CD',
	PRIMARY_COLOR_1: '#F0F7FF',
	PRIMARY_COLOR_2: '#D4E6FF',
	PRIMARY_COLOR_7: '#173DA6',
	SECONDARY_COLOR: '#EC9A29',
	WHITE_COLOR: '#FFFFFF',
	TEXT_COLOR: '#262626',
	LABEL_COLOR: '#595959',
	MENU_ITEM_TEXT_COLOR: '#232835',
	ICON_COLOR: '#8C8C8C',
	ICON_HOVER_BG: '#F0F0F0',
	MODAL_BG: '#F5F5F5',
	LAYOUT_BG: 'linear-gradient(250deg, #EBF3FF 31.51%, #FFF7E2 96.19%)',
};

//  ['#F0F7FF', '#D4E6FF', '#A2C2F2', '#759EE6', '#4C7BD9', '#2759CD', '#173DA6', '#0B2780', '#041559', '#020A33'];

const theme: ThemeConfig = {
	algorithm: defaultTheme.defaultAlgorithm,
	token: {
		fontFamily: 'Inter',
		colorPrimary: VAR.PRIMARY_COLOR,
		colorInfo: VAR.PRIMARY_COLOR,
		colorText: VAR.TEXT_COLOR,
		fontSize: 14,
		borderRadius: 6,
	},
	components: {
		Button: {
			primaryShadow: '0px 4px 6px 0px #2759CD33',
			defaultShadow: '0px 1px 6px -1px #00000005, 0px 1px 2px 0px #00000008, 0px 2px 4px 0px #00000005',
			defaultBorderColor: 'transparent',
		},
		Segmented: {
			// TODO
			// trackBg: VAR.WHITE_COLOR,
			// itemSelectedBg: VAR.PRIMARY_COLOR_1,
		},
		Tabs: {
			cardBg: VAR.WHITE_COLOR,
		},
		Descriptions: {
			labelColor: VAR.LABEL_COLOR,
		},
		Form: {
			labelColor: VAR.LABEL_COLOR,
		},
		Tag: {
			fontSize: 12,
			fontSizeSM: 12,
		},
		Typography: {
			colorTextDescription: VAR.ICON_COLOR,
			fontWeightStrong: 500,
		},
		Splitter: {
			splitBarSize: 0,
		},
	},
};

const proLayoutTheme: ProTokenType['layout'] = {
	bgLayout: VAR.LAYOUT_BG,
	colorPrimary: VAR.PRIMARY_COLOR,
	header: {
		heightLayoutHeader: 90,
	},
	sider: {
		colorTextMenu: VAR.MENU_ITEM_TEXT_COLOR,
		colorTextMenuSelected: VAR.PRIMARY_COLOR_7,
		colorBgMenuItemSelected: VAR.PRIMARY_COLOR_2,
		menuHeight: 37,
		paddingInlineLayoutMenu: 12,
		paddingBlockLayoutMenu: 10,
	},
	pageContainer: {
		paddingInlinePageContainerContent: 30,
		paddingBlockPageContainerContent: 8,
	},
};

const proLayoutHeaderTheme: ProTokenType['layout'] = {
	colorPrimary: VAR.PRIMARY_COLOR,
	header: {
		colorTextMenuSelected: VAR.SECONDARY_COLOR,
		colorTextMenuActive: VAR.WHITE_COLOR,
		colorTextMenu: '#A2C2F2',
	},
};

const settingLayoutTheme: ProTokenType['layout'] = {
	bgLayout: VAR.LAYOUT_BG,
	colorPrimary: VAR.PRIMARY_COLOR,
	sider: {
		...proLayoutTheme.sider,
		menuHeight: 32,
	},
	pageContainer: {
		paddingInlinePageContainerContent: 30,
		paddingBlockPageContainerContent: 8,
	},
};

export { theme, proLayoutTheme, proLayoutHeaderTheme, settingLayoutTheme, VAR as VARIABLES };
